import Vue from 'vue';
import dayjs from 'dayjs';
import store from '../store';

Vue.filter('dateFormatFromSettings', str => {
    if (!str) {
        return '';
    }

    const settings = store.getters['settings/getSettings'];

    if (settings) {
        return dayjs(str).format(settings.dateFormat);
    }

    return str;
});
